import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import * as d3 from "d3";
import * as ss from "simple-statistics";
import * as _ from "lodash";
import cfg from "../config.json";
import * as ut from "../lib/utils.js";
const MTL_LOCATION = [-73.66,45.56];
const QC_LOCATION = [-71.23,46.83];
let LOCATION_FALLBACK = MTL_LOCATION;
const INITIAL_ZOOM = 10;
const MAPBOX_ACCESS_TOKEN = "pk.eyJ1IjoiaW5mb2pkZW0iLCJhIjoiY21pNmMzcXlrMHFndTJqcHBpNXdjcWthZSJ9.VIo8D6gzlnCXcB4BgfH6lg"
const MAP_STYLE_URL = "mapbox://styles/infojdem/cld3l91wl000201qwfl1cfcaa";
var _map, geolocate_control, ecolesData, ehdaaData;
var selectedEcoleId = null;
var show_details = false;

export function map(sel, data) {
  let trendEqual = cfg.iconTrendEqual;
  let trendUp = cfg.iconTrendUp;
  let trendDown = cfg.iconTrendDown;

  var MAP_RESOURCES = [
    {
      path: cfg.assetsFolder+"pub-high.png",
      id: "pub-high",
      loaded: false
    },
    {
      path: cfg.assetsFolder+"pub-med.png",
      id: "pub-med",
      loaded: false
    },
    {
      path: cfg.assetsFolder+"pub-low.png",
      id: "pub-low",
      loaded: false
    },
    {
      path: cfg.assetsFolder+"pri-high.png",
      id: "pri-high",
      loaded: false
    },
    {
      path: cfg.assetsFolder+"pri-med.png",
      id: "pri-med",
      loaded: false
    },
    {
      path: cfg.assetsFolder+"pri-low.png",
      id: "pri-low",
      loaded: false
    },
  ]

  process_data();
  setTimeout(function(){ init(); }, 500);

  function process_data() {
    const rawEcoles = data.ecoles;
    const rawEhdaa = data.ehdaa;

    // Calc rank quantiles
    let prv = _.filter(rawEcoles, (d) => { return d.secteur == "privé"; })
    let pub = _.difference(rawEcoles, prv)

    let prvc = _.map(prv, (d) => { return parseFloat(d.cote_2024); })
    let pubc = _.map(pub, (d) => { return parseFloat(d.cote_2024); })

    let stats = {
      "privé":  { quantiles: [ss.quantile(prvc,0.20), ss.quantile(prvc,0.67)] },
      "public": { quantiles: [ss.quantile(pubc,0.20), ss.quantile(pubc,0.67)] }
    }

    // Ecoles
    let features = _
        .chain(rawEcoles)
        .each(function(d){
          d.compared = false;
          d.admin_body_name = d.admin_body_name.replace('CS ', 'Commission scolaire ')
          let cotes = _
              .chain([+d.cote_2018, +d.cote_2019, +d.cote_2022, +d.cote_2023, +d.cote_2024])
              .filter(function(d){ return !isNaN(d); })
              .value()
          d.cote_moyenne = _.reduce(cotes, function(memo,d){ return memo+d; }) / cotes.length
          let qs = stats[d.secteur].quantiles
          let c = +d.cote_2024
          if (c < qs[0]) {
            d.icon = d.secteur == "public" ? "pub-low" : "pri-low";
          }
          else if (c >= qs[1]) {
            d.icon = d.secteur == "public" ? "pub-high" : "pri-high";
          }
          else {
            d.icon = d.secteur == "public" ? "pub-med" : "pri-med";
          }
        })
        .filter("valid")
        .sortBy('lat')
        .reverse()
        .map(d => {
          return {
            "id": +d.school_code,
            "type": "Feature",
            "geometry": {
              "type": "Point",
              "coordinates":  [d.lng,d.lat]
            },
            "properties": d
          }
        })
        .value()

    ecolesData = {
      "type": "FeatureCollection",
      "features": features
    }

    // EHDAA
    ehdaaData = _
        .chain(rawEhdaa)
        .each(d => d)
        // .each((d) => { d.admin = d.admin.replace('CS ', 'Commission scolaire '); })
        .value();
  }

  function init() {
    var hostURL = (window.location !== window.parent.location)
        ? document.referrer.split('/')[2]
        : window.location.host;
    if((hostURL === "www.journaldequebec.com") || (hostURL === "jdq.qub.ca")) {
      LOCATION_FALLBACK = QC_LOCATION;
    }

    mapboxgl.accessToken = MAPBOX_ACCESS_TOKEN;
    _map = new mapboxgl.Map({
      attributionControl: false,
      bearing: 0,
      center: LOCATION_FALLBACK,
      container: sel.attr("id"),
      interactive: true,
      language: ["fr", "fr-CA"],
      locale: {
        "FullscreenControl.Enter": "Plein écran",
        "FullscreenControl.Exit": "Retour à la page",
        "GeolocateControl.FindMyLocation": "Me référencer",
        "NavigationControl.ZoomIn": "S'approcher",
        "NavigationControl.ZoomOut": "S'éloigner"
      },
      maxPitch: 60,
      minZoom: 5,
      pitch: 0,
      projection: 'globe',
      style: MAP_STYLE_URL,
      zoom: INITIAL_ZOOM,
      showUserLocation:true
    });

    /** CONTROLS
    if (ut.is_mobile()) {
      // map.dragPan.disable();
      _map.addControl(new mapboxgl.NavigationControl({
        showCompass: false
      }), "bottom-right");
      // map.addControl(new mapboxgl.GeolocateControl({
      //   fitBoundsOptions: { maxZoom: 12 }
      // }), "bottom-right");
    } else {
      _map.addControl(new mapboxgl.NavigationControl({
        showCompass: false
      }), "bottom-right");

      // map.addControl(new mapboxgl.GeolocateControl({
      //   fitBoundsOptions: { maxZoom: 12 }
      // }));
    } **/

    _map.add_marker = function(ll, color) {
      new mapboxgl.Marker({ color: color })
        .setLngLat(ll)
        .addTo(map);
    };

    _map.on("click", () => {
      document.dispatchEvent(new CustomEvent('map-click', { bubbles: true }));
    });

    _map.on("movestart", () => {
      document.dispatchEvent(new CustomEvent('map-move-start', { bubbles: true }));
    });

    _map.on("move", () => {
      let lat = _map.getCenter()["lat"];
      let lng = _map.getCenter()["lng"];
      let zoom = _map.getZoom();
      let pitch = _map.getPitch();
      let bearing = _map.getBearing();
      // console.log(`center:[${lat}, ${lng}], zoom:${zoom}, pitch:${pitch}, bearing:${bearing}`);
    });

    _map.on("moveend", () => {
      document.dispatchEvent(new CustomEvent('map-move-end', { bubbles: true }));
    });

    _map.on("zoomstart", () => {
      document.dispatchEvent(new CustomEvent('map-zoom-start', { bubbles: true }));
    });

    _map.on('load', () => {
      init_user_location();
      load_resources();

      const iid = setInterval(function(){
        if (MAP_RESOURCES.every(d => d.loaded)) {
          clearInterval(iid);
          init_layers();
          init_user_location();
          init_place_search();
        }
      }, 100);

      function resized() {
        _map.resize();
      }
      window.onresize = resized;
    });

    // Map related events
    document.addEventListener("map-click", on_map_clicked, false);
    document.addEventListener("map-move-start", on_map_move_started);
    document.addEventListener("map-move-end", on_map_move_ended);
    document.addEventListener("map-zoom-start", on_map_zoom_started);
    // Comparator related events
    document.addEventListener("comparator-school-added", on_comparator_school_added);
    document.addEventListener("comparator-school-removed", on_comparator_school_removed);
    document.addEventListener("comparator-toggled-from-button", (e)=> {on_toggled_comparator(e.detail,false)});

    d3.select(".info-bg").on("click", on_map_clicked);
  }

  // User geolocation
  function init_user_location() {
    /** Geolocation is not permitted in an iFrame. So until then, fallback **/
    /**

    if (geolocate_control !== undefined) return;

    geolocate_control = new mapboxgl.GeolocateControl({
      fitBoundsOptions: { maxZoom: 14 },
      positionOptions: {
        enableHighAccuracy: true
      },
      trackUserLocation: false,
      showUserHeading: true
    });

    geolocate_control.on("geolocate", (e) => {
      const home_location = [e.coords.longitude, e.coords.latitude];
      fly_to(home_location, INITIAL_ZOOM);
    });

    if (ut.is_mobile()) {
      _map.addControl(geolocate_control, "bottom-right");
    } else {
      _map.addControl(geolocate_control);
    }

    setTimeout(() => { geolocate_control.trigger(); }, 1000);
   **/

    /** Fallback :  **/
    // var hostURL = (window.location !== window.parent.location)
    //     ? document.referrer.split('/')[2]
    //     : window.location.host;
    // if((hostURL === "www.journaldequebec.com") || (hostURL === "jdq.qub.ca")) {
    //   fly_to(QC_LOCATION,INITIAL_ZOOM);
    // } else {
    //   fly_to(MTL_LOCATION,INITIAL_ZOOM);
    // }
  }

  function fly_to(ll, z) {
    if (_map) {
      _map.flyTo({center:ll, zoom:z});
    } else {
      console.error("map not loaded. Won't go anywhere");
    }
  }

  function load_resources() {
    MAP_RESOURCES.forEach(d => {
      _map.loadImage(`${d.path}`, (error, image) => {
        if (error) throw error;
        _map.addImage(d.id, image);
        d.loaded = true
      });
    });
  }

  function init_layers() {
    const geodata = {
      type: "FeatureCollection",
      features: []
    };

    _map.addSource("ecoles", {
      type: "geojson",
      data: ecolesData
      // cluster: true,
      // clusterMaxZoom: 15, // Max zoom to cluster points on
      // clusterRadius: 50 // Radius of each cluster when clustering points (defaults to 50)
      // 'generateId': true //This ensures that all features have unique IDs
    });

    _map.addLayer({
      "id": "distant",
      "source": "ecoles",
      'type': 'circle',
      'paint': {
        "circle-stroke-width": 2,
        "circle-stroke-color": '#FFFFFF',
        'circle-radius': {
          'base': 15,
          'stops': [
            [6, 2],
            [9, 3]
          ]
        },
        'circle-color': '#000000',
        'circle-opacity': [
          "interpolate", ["linear"], ["zoom"],
          6, 1,
          9, 1,
          10, 0
        ]
      }
    });

  // _map.addLayer({
  //   id: 'clusters',
  //   type: 'circle',
  //   source: 'ecoles',
  //   filter: ['has', 'point_count'],
  //   paint: {
  //     'circle-color': "#FFFFFF",
  //     'circle-radius': [
  //       'step',
  //       ['get', 'point_count'],
  //       15, 10,
  //       20
  //     ],
  //     'circle-opacity': 0.9,
  //     "circle-stroke-color": "#0a3ddc",
  //     "circle-stroke-opacity": 1,
  //     "circle-stroke-width": 2
  //   }
  // });

  // _map.addLayer({
  //   id: 'cluster-count',
  //   type: 'symbol',
  //   source: 'ecoles',
  //   filter: ['has', 'point_count'],
  //   layout: {
  //     'text-field': [
  //       'step',
  //       ['get', 'point_count'],
  //       "",
  //       1,"1",
  //       2,"2",
  //       3,"3",
  //       4,"4",
  //       5,"5",
  //       6,"6",
  //       7,"7",
  //       8,"8",
  //       9,"9",
  //       10, "10+",
  //       25, "25+",
  //       50, "50+",
  //       100, "100+"
  //     ],
  //     'text-font': ['DIN Offc Pro Bold', 'Arial Unicode MS Bold'],
  //     'text-size': [
  //       'step',
  //       ['get', 'point_count'],
  //       20, 10,
  //       20
  //     ],
  //   },
  //   paint: {
  //     'text-opacity': 1,
  //     'text-color': '#0a3ddc'
  //   }
  // });


    _map.addLayer({
      "id": "labels",
      "source": "ecoles",
      'type': 'symbol',
      'layout': {
        'text-field': ['get', 'school_name_1'],
        'text-variable-anchor': ['top'],
        'text-radial-offset': 1.5,
        'text-justify': 'auto',
        'text-font': ['literal', ['Heading Now 55 Medium Italic', 'Open Sans Bold Italic', 'Arial Unicode MS Bold']],
        'text-size': [
          "interpolate", ["linear"], ["zoom"],
          13, 12,
          15, 17
        ],
        'text-allow-overlap': false,
        'text-ignore-placement': false
      },
      'paint': {
        'text-color': "#000000",
        'text-halo-color': "#FFFFFF",
        'text-halo-width': 2,
        'text-halo-blur': 0,
        'text-opacity': [
          "interpolate", ["linear"], ["zoom"],
          12, 0,
          15, 1
        ]
      }
    });

    _map.addLayer({
      "id": "symbols",
      "source": "ecoles",
      'type': 'symbol',
      'layout': {
        'icon-image': ["get", "icon"],
        'icon-size': [
          "interpolate", ["linear"], ["zoom"],
          3, 0.01,
          12, 0.04
        ],
        'text-allow-overlap': true,
        'text-ignore-placement': true,
        'icon-allow-overlap': true,
        'icon-ignore-placement': true
      },
      'paint': {
        'icon-opacity': [
          "interpolate", ["linear"], ["zoom"],
          6, 0,
          9, 0,
          10, 1,
          12, 1
        ]
      }
    });

    _map.addLayer({
      "id": "selection",
      "source": "ecoles",
      'type': 'circle',
      'paint': {
        "circle-radius": ["case", ['boolean', ['feature-state', 'selected'], false], 3, 0],
        'circle-color': '#000000',
        "circle-stroke-width": 0
      }
    });

    _map.on('mouseenter', ["symbols", "labels"], function () {
      _map.getCanvas().style.cursor = 'pointer';
    })

    _map.on('mouseleave', ["symbols", "labels"], function () {
      _map.getCanvas().style.cursor = '';
    });

    _map.on('click', ['symbols', 'labels'], function (e) {
      const bbox = [
        [e.point.x - 5, e.point.y - 5],
        [e.point.x + 5, e.point.y + 5]
      ];
      const features = _map.queryRenderedFeatures(bbox);

      update_map_selection_hints(features[0].id);

      // Ensure that if the map is zoomed out such that multiple
      // copies of the feature are visible, the popup appears
      // over the copy being pointed to.
      const coords = e.features[0].geometry.coordinates.slice();
      while (Math.abs(e.lngLat.lng - coords[0]) > 180) {
        coords[0] += e.lngLat.lng > coords[0] ? 360 : -360;
      }

      // Configure infobox (or map popup) content
      const d = data.ecoles.find(d => d.school_code == e.features[0].properties.school_code);

      // collapsed by default
      show_details = false;

      d3.select("#info")
        .html(info_content_html(d))
        .classed("hidden", false)

      if(window.matchMedia(cfg.mobileQuery).matches) {
        d3.select(".info-bg").classed("hidden", false)
      }


      d3.select(".info-content #toggle-comparison input")
        .datum(d)
        .on("click", toggle_comparison);

      d3.select(".info-content #toggle-details")
        .datum(d)
        .on("click", toggle_details);

      d3.select(".info-content #close-info")
        .on("click", function(e) {
          d3.select("#info").classed("hidden", true);
          d3.select(".info-bg").classed("hidden", true);
          update_map_selection_hints(null);
        });
    });
  }

  function info_content_html(d) {
    const id = `school-${d.school_code}`;
    var lang = "";
    if (d.langue == "français") {
      lang = "francophone";
    } else if (d.langue == "anglais") {
      lang = "anglophone";
    } else if (d.langue == "français, anglais") {
      lang = "bilingue";
    }
    const sect = d.secteur == "public" ? "publique" : "privée";
    const type = `École ${lang} ${sect}`;
    const compared = data.ecoles.filter(d => d.compared);
    const comparison_disable = compared.length == cfg.maxCompare  && ! d.compared ? "disabled" : "";
    const comparison_check = d.compared ? "checked" : "";
    const comparison_html = d.compared ? `<span class="underline">Retirez</span> cette école du comparateur` : `<span class="underline">Ajoutez</span> cette école au comparateur`;
    const rang_num = d.rang_2024.split("/")[0];
    const rang_den = d.rang_2024.split("/")[1];
    const toggle_details_class = show_details ? "active" : "" ;
    const toggle_details_text = show_details ? "Masquez" : "Affichez" ;
    const toggle_details_icon = show_details ? "expand_less" : "expand_more" ;
    const details_class = show_details ? "" : "hidden";

    const returnProperIcon = (trend) => {
      let icon = trend === '112233' ? trendUp : trendEqual;
      icon = trend === "998855" ? trendDown : icon;
      return trend === "nd" ? "nd" : icon;
    }
    const pnum = function(str) {
      if (str == "nd") return str;
      return ("" + str).replace(/\./, ",");
    }
    const ppct = function(str) {
      if (str == "nd") return str;
      return ("" + str).replace(/\./, ",") + "%";
    }

    let html = `
      <div class="info-content" id="${id}">

        <div id="toggle-comparison" class="bg-darkblue tx-white flex mb3 info-content-header ${comparison_disable}">
          <input id="comparison-checkbox" type="checkbox" ${comparison_check} ${comparison_disable} class="mr3" />
          <label for="comparison-checkbox">${comparison_html}</label>
        </div>
        
        <div class="scrollable-content">
        
        <div class="bg-brightyellow tx-blue tx-upp tx-bold mb3 flex">
          &nbsp;${type} <span id="close-info"><span class="material-symbols-rounded">close</span></span>
        </div>

        <h1 class="ma0 mb2 leading-none tx-darkblue tx-bold school-name">${d.school_name_1}</h1>
        <div class="mb4 tx-gray tx-bold school-address">${d.adresse}, ${d.municipalite}</div>

        <div class="flex mb2">
          <div class="text-center w-full">
            <div class="bg-brightyellow tx-blue tx-bold font-medium mb2 tx-upp">Cote globale</div>
            <div class="bg-lightblue-res tx-darkblue tx-bold vignette-nb">${pnum(d.cote_2024)} <span class="semi-opaque">/10</span></div>
          </div>
          <div class="text-center w-full ml1">
            <div class="bg-brightyellow tx-blue tx-bold font-medium mb2 tx-upp">Classement</div>
            <div class="bg-lightblue-res tx-darkblue tx-bold vignette-nb">${rang_num} <span class="semi-opaque">/${rang_den}</span></div>
          </div>
        </div>

        <table class="mb2">
          <tr>
            <td class="">&nbsp;Nombre d'élèves</td>
            <td class="text-right tx-bold tx-darkblue pr2">${d.étudiants}</td>
          </tr>
          <tr>
            <td class="">&nbsp;En retard</td>
            <td class="text-right tx-bold tx-darkblue">${ppct(d.en_retard_2024)}&nbsp;</td>
          </tr>
          <tr>
            <td class="">&nbsp;EHDAA</td>
            <td class="text-right tx-bold tx-darkblue">${ppct(d.ehdaa_2024)}</td>
          </tr>
        </table>

        <hr class="mb4" />

        <div id="toggle-details" class="flex justify-between pointer tx-blue ${toggle_details_class}">
          <div><span class="verb underline">${toggle_details_text}</span> tous les détails</div>
          <div><span class="material-symbols-rounded icon">${toggle_details_icon}</span></div>
        </div>

        <div id="info-content-details" class="${details_class}">

         <table class="resultats">
           <thead class="bg-brightyellow tx-blue tx-upp tx-bold">
             <th class="text-left">Résultats <span class="">(%)</span></td>
             <th class="text-right">2024</td>
             <th class="text-center">Tend.</td>
           </thead>
           <tbody>
             <tr>
               <td>Langue d'enseignement</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.lens_2024)}</td>
               <td class="text-center">${returnProperIcon(d.lens_trend)}</td>
             </tr>
             <tr>
               <td>Langue seconde</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.lsec_2024)}</td>
               <td class="text-center">${returnProperIcon(d.lsec_trend)}</td>
             </tr>
             <tr>
               <td>Science et technologie</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.scie_2024)}</td>
               <td class="text-center">${returnProperIcon(d.scie_trend)}</td>
             </tr>
             <tr>
               <td>Mathématiques</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.math_2024)}</td>
               <td class="text-center">${returnProperIcon(d.math_trend)}</td>
             </tr>
             <tr>
               <td>Taux d'échec</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.echec_2024)}</td>
               <td class="text-center">${returnProperIcon(d.echec_trend)}</td>
             </tr>
           </tbody>
         </table>

         <table class="resultats">
           <thead class="bg-brightyellow tx-blue tx-upp tx-bold">
             <th class="text-left">Autres facteurs <span class="">(%)</span></td>
             <th class="text-right">2024</td>
             <th class="text-center">Tend.</td>
           </thead>
           <tbody>
             <tr>
               <td>Surestimation</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.sures_2024)}</td>
               <td class="text-center">${returnProperIcon(d.sures_trend)}</td>
             </tr>
             <tr>
               <td>Écarts sexes : langue</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.ecart_sexes_lens_2024)}</td>
               <td class="text-center">${returnProperIcon(d.ecart_sexes_lens_trend)}</td>
             </tr>
             <tr>
               <td>Écarts sexes : math.</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.ecart_sexes_math_2024)}</td>
               <td class="text-center">${returnProperIcon(d.ecart_sexes_math_trend)}</td>
             </tr>
             <tr>
               <td>Taux de retard</td>
               <td class="text-right tx-bold tx-darkblue">${pnum(d.prog_2024)}</td>
               <td class="text-center">${returnProperIcon(d.prog_trend)}</td>
             </tr>
           </tbody>
         </table>
         
         </div>

        </div>

      </div>
    `;

    return html;
  }

  function update_map_selection_hints(id) {
    if (selectedEcoleId !== null) {
      _map.setFeatureState(
        {source: 'ecoles', id: selectedEcoleId},
        {selected: false}
      );
    }

    if (id) {
      selectedEcoleId = id;
      _map.setFeatureState(
        {source: 'ecoles', id: selectedEcoleId},
        {selected: true}
      );
    }
  }

  function toggle_comparison(e, d) {
    const checked = d3.select(this).property("checked");
    d.compared = checked;

    const msg = checked ? "map-school-selected" : "map-school-deselected";
    document.dispatchEvent(new CustomEvent(msg, { detail: d }));

    const html = checked ? `<label for="comparison-checkbox"><span class="underline">Retirez</span> cette école du comparateur</label>` : `<label for="comparison-checkbox"><span class="underline">Ajoutez</span> cette école au comparateur</label>`
    d3.select(".info-content #toggle-comparison label").html(html);
  }
  
  function toggle_details(e, d) {
    show_details = ! show_details;
    const toggle_text = show_details ? "Masquez" : "Affichez";
    const toggle_details_icon = show_details ? "expand_less" : "expand_more" ;
    d3.select(this).classed("active", d3.select(this).classed("active") ? false : true);
    d3.select("#info-content-details").classed("hidden", !show_details);
    d3.select("#toggle-details .verb").text(toggle_text);
    d3.select("#toggle-details .icon").text(toggle_details_icon);
  }
  
  function on_comparator_school_added(e) {
    const d = data.ecoles.find(d => d.school_code == e.detail.school_code);
    d.compared = true;
    const compared_ids = data.ecoles.filter(d => d.compared).map(d => d.school_code);
    const cur_sel = d3.select(".info-content");
    if (! cur_sel.empty()) {
      const id = cur_sel.attr("id").replace(/school-/, "");
      const inp = cur_sel.select("#toggle-comparison input");
      const lab = cur_sel.select("#toggle-comparison label");
      if (compared_ids.indexOf(id) != -1) {
        inp.property("checked", true);
        lab.html(`<label for="comparison-checkbox"><span class="underline">Retirez</span> cette école du comparateur</label>`);
      } else if (compared_ids.length == cfg.maxCompare) {
        cur_sel.select("#toggle-comparison").classed("disabled", true);
        inp.property("disabled", true);
      }
    }
  }

  function on_comparator_school_removed(e) {
    const d = data.ecoles.find(d => d.school_code == e.detail.school_code);
    d.compared = false;
    const sel = d3.select(".info-content");
    if (! sel.empty()) {
      const div = sel.select("div#toggle-comparison");
      const inp = div.select("input");
      const lab = div.select("label");
      div.classed("disabled", false);
      inp.property("disabled", false);
      if (sel.attr("id") == `school-${d.school_code}`) {
        inp.property("checked", false);
        lab.html(`<label for="comparison-checkbox"><span class="underline">Ajoutez</span> cette école au comparateur</label>`);
      }
    }
  }

  function init_place_search() {
    let search_widget = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      localGeocoder: forwardGeocoderEcoles,
      zoom: 15,
      countries: 'ca',
      bbox: [-80.810452,44.860614,-56.684475,63.266310],
      marker: false,
      mapboxgl: mapboxgl,
      language: 'fr-CA',
      filter: function (item) {
        if (item.context) {
          return item.context.some((i) => {
            return (
              i.id.split('.').shift() === 'region' && i.text === 'Québec'
            );
          });
        } else {
          return item.type == "Feature";
        }
      },
      limit: 7,
      types:'place',
      placeholder: 'Rechercher une école secondaire',
      clearOnBlur: true,
    });

    search_widget
      .on('result', (selection) => {
        search_widget.clear();
        _map.once('moveend', function () {
        // project to use (pixel xy coordinates instead of lat/lon for WebGL)
        _map.project([selection.result.center[0], selection.result.center[1]]);

        update_map_selection_hints(selection.result.id);

        if (typeof selection.result.properties !== "undefined") {
          d3.select("#info")
            .html(info_content_html(selection.result.properties))
            .classed("hidden", false)

          if(window.matchMedia(cfg.mobileQuery).matches) {
              d3.select(".info-bg").classed("hidden", false)
          }

          d3.select(".info-content #toggle-comparison input")
            .datum(selection.result.properties)
            .on("click", toggle_comparison);

          d3.select(".info-content #toggle-details")
            .datum(selection.result.properties)
            .on("click", toggle_details);

          d3.select(".info-content #close-info")
            .on("click", function(e) {
              d3.select("#info").classed("hidden", true);
              d3.select(".info-bg").classed("hidden", true);
              update_map_selection_hints(null);
            });
        }
      });
    });

    function forwardGeocoderEcoles(query) {
      const matchingFeatures = [];
      for (const feature of ecolesData.features) {
        if (feature.properties.school_name_1.toLowerCase().includes(query.toLowerCase()) ||
            feature.properties.municipalite.toLowerCase().includes(query.toLowerCase())) {
          feature['place_name'] = `︎︎» ${feature.properties.school_name_1} (${feature.properties.municipalite})`;
          feature['center'] = feature.geometry.coordinates;
          matchingFeatures.push(feature);
        }
      }
      return matchingFeatures;
    }

    _map.addControl(search_widget,'top-left');
    search_widget.container.parentNode.className="mapboxgl-ctrl-top-center"
  }

  function on_map_clicked() {
    update_map_selection_hints(null);
    d3.select("#info").classed("hidden", true);
    on_toggled_comparator('close',true);
  }

  function on_toggled_comparator(openOrClose,dispatchNeeded) {
    if(openOrClose === "open") {
      update_map_selection_hints(null);
      d3.select(".info-bg").classed("hidden", false);
      d3.select("#info").classed("hidden", true);
    } else {
      d3.select(".info-bg").classed("hidden", true);
    }
    if(dispatchNeeded) {
      document.dispatchEvent(new CustomEvent("comparator-toggled-from-map", {detail : openOrClose}));
    }
  }

  function on_map_move_started() {
  }

  function on_map_move_ended() {
  }

  function on_map_zoom_started() {
  }
}
